

function userMoneyFormat(){
 function moneyFormat(n:number) {
    return Number((n).toFixed(1)).toLocaleString();
}
 return{moneyFormat};
}

export default userMoneyFormat;